import { render, staticRenderFns } from "./inputNumber.vue?vue&type=template&id=52ec1f13&scoped=true&"
import script from "./inputNumber.vue?vue&type=script&lang=js&"
export * from "./inputNumber.vue?vue&type=script&lang=js&"
import style0 from "./inputNumber.vue?vue&type=style&index=0&id=52ec1f13&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ec1f13",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SvgIcon: require('/app/components/svgIcon/svgIcon.vue').default})
